
import { isTestEnv } from '@root/helpers/shared';
export const POOL_DATA = isTestEnv() ? {
    UserPoolId: 'eu-central-1_dxtkDNaOC',
    ClientId: '5af6lbq46akf1js3b3l1ohkohq'
} : {
    UserPoolId: 'eu-central-1_xRLuNM7NP',
    ClientId: '5214c89v8q97la2isma66ufgvu'
};